/* eslint-disable react/no-array-index-key */
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { WithStyles } from '@material-ui/core';
//use useParams
import { useParams, useNavigate } from 'react-router-dom';
import { get } from 'lodash-es';
import { generateStyle } from '../../utils/styles';
import Style from './style';
//import { RootState } from '../../reducers';
import { UrlParams } from '../../constants/props';
import { SetClientId, SetClientNonce, SetClientState, SetRedirectUrl } from '../HomePage/types';

interface Props extends WithStyles<typeof Style> {
	[name: string]: any;
}

const Home: React.FC<Props> = ({ classes }: Props) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const params = useParams() as UrlParams;
	const appCode = params.appCode;
	const search = get(window, 'location.search', '');
	const query = new URLSearchParams(search);

	const client_id = query.get('client_id') as string;
	const state = query.get('state') as string;
	const nonce = query.get('nonce') as string;
	const redirect_url = query.get('redirect_url') as string;

	const alertUser = (e: any) => {
		// e.preventDefault();
		// e.returnValue = '';
		// window.open("https://google.com")
	};

	useEffect(() => {
		window.addEventListener('beforeunload', alertUser);
		return () => {
			window.removeEventListener('beforeunload', alertUser);
		};
	}, []);

	useEffect(() => {
		if (client_id) {
			dispatch(SetClientId.action(client_id));
			dispatch(SetClientState.action(state));
			dispatch(SetClientNonce.action(nonce));
			dispatch(SetRedirectUrl.action(redirect_url));
			navigate('/login', { replace: true });
		} else {
			navigate('/error', { replace: true });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch, appCode, client_id, state, nonce]);

	return <div></div>;
};

export default generateStyle(Style, 'Home')(Home);
